const ModuleHomeUrl = {
  'core.tier.T1': {
    resourcecentre: '/resourcecentre/home/admin',
  },
  'core.tier.T2': {
    resourcecentre: '/resourcecentre/home',
    vdoc: '/documents/home',
    import: '/admin2/import',
    inspection: '/inspection/home/template?archived=false',
    safetyplan: '/safety-plan/home?tab=tp',
    sysfield: '/wmm/sys-fields/home',
  },
  'core.tier.T3': {
    correspondence: '/correspondence/home?tab=cm',
    action: '/action/home',
    inspection: '/inspection/home',
    chemical: '/chemical/home',
    contractor: '/contractor/home',
    vdoc: '/documents/home',
    hr: '/people/home',
    training: '/people/home?tab=tr',
    incident: '/ai/home',
    injurymgmt: '/inj-m/home',
    reviewplan: '/review-plan/home?tab=li',
    safetyplan: '/safety-plan/home',
    visitor: '/visitor/home',
    noticeboard: '/noticeboard/home',
    corporateRisk: '/crisk/home',
    asset: '/assets/home',
    qrcode: '/qr-code/home',
  },
  'core.tier.T4': {
    correspondence: '/correspondence/home?tab=cm',
    action: '/action/home',
    inspection: '/inspection/home',
    chemical: '/chemical/home',
    contractor: '/contractor/home',
    vdoc: '/documents/home',
    hr: '/people/home',
    training: '/people/home?tab=tr',
    incident: '/ai/home',
    injurymgmt: '/inj-m/home',
    reviewplan: '/review-plan/home',
    safetyplan: '/safety-plan/home',
    visitor: '/visitor/home',
    noticeboard: '/noticeboard/home',
    corporateRisk: '/crisk/home',
    asset: '/assets/home',
    qrcode: '/qr-code/home',
  },
  'core.tier.T5': { action: '/action/home' },
};
export default ModuleHomeUrl;
